import Component from './lottery_page_dialog.vue'
export default Component
